


























import CommonBase from "../CommonBase";
import {Component, Emit, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import {CountryCode, PhoneNumber} from "../../modules/models";

@Component
export default class Phoneinput extends CommonBase {
    @Inject()
    api!: Api;

    @Prop({default: null})
    value!: PhoneNumber | null;

    @Prop({default: false})
    required!: boolean;
    @Prop({default: false})
    autofocus!: boolean;
    @Prop({default: () => []})
    errorMessages!: string[];
    @Prop({default: "tel-national"})
    autocomplete!: string;

    countrycodes: CountryCode[] = [];

    @Emit("at-phone-entered")
    entered() {}

    hasChanged = false;

    //countryCode = 47;
    //phoneNum: number | null = null;
    get countryCode() {
        if(this.value != null) {
            return this.value.countrycode;
        }
        return 47;
    }
    set countryCode(cc: number) {
        let v = this.value;
        if(v == null) {
            v = new PhoneNumber(cc, 0);
        } else {
            v.countrycode = cc;
        }
        this.$emit("input", v);
    }
    get phoneNum(): number | null {
        if(this.value != null && this.value.number > 0) {
            return this.value.number;
        } else {
            return null;
        }
    }
    set phoneNum(n: number | null) {
        let v = this.value;
        if(n != null) {
            if(v == null) {
                v = new PhoneNumber(47, n);
            } else {
                v.number = n;
            }
        } else {
            v = null;
        }
        this.$emit("input", v);
        this.hasChanged = true; // So that validation kicks in
    }

    get numMask() {
        if(this.countryCode === 47) {
            return "## ## ## ##";
        }
        return "### ### ### ###"; // For other countries we don't know how the correct mask, just have room for enough digits should work.
    }

    async loadCountrycodes() {
        this.countrycodes = await this.api.fetchPhoneCountryCodes();
    }

    validateCountry() {
        if(!(this.countryCode > 0)) {
            return "Ugyldig. Bruk +47 for Norge";
        }
        return true;
    }
    validateNum() {
        if(this.required && this.hasChanged && this.phoneNum == null) {
            return "Telefonnr må fylles ut";
        }
        if(this.phoneNum != null) {
            if (this.phoneNum <= 0) {
                return "Ugyldig. Må være positivt heltall";
            } else if(this.phoneNum < 99999 ) {
                return "For få siffer";
            } else if(this.phoneNum > 999999999999) {
                return "For mange siffer";
            }
        }
        return true;
    }

    created() {
        this.loadCountrycodes();
    }
}
